import { Link } from "react-router-dom";
import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";

// Referenced from the Terms of Service (§8) and Acceptable Use Policy (§4)
// as xpert.company/legal/report. Notice-and-takedown + abuse reporting.
export default function ReportContentPage() {
  return (
    <div className="min-h-screen bg-canvas">
      <MarketingNav />
      <main className="max-w-3xl mx-auto px-5 py-16">
        <Link to="/legal/acceptable-use" className="text-sm text-brand-green hover:text-brand-greenHover">← Acceptable Use Policy</Link>
        <h1 className="font-display text-4xl mt-4 mb-3">Report content or abuse</h1>
        <p className="text-slateline-600 leading-relaxed mb-8">
          If something on xpert.company infringes your rights, breaks our{" "}
          <Link to="/legal/acceptable-use" className="text-brand-green underline hover:no-underline">Acceptable Use Policy</Link>,
          or otherwise needs our attention, tell us. We review every report and act where appropriate,
          and we terminate the accounts of repeat infringers.
        </p>

        <section className="space-y-8">
          <div>
            <h2 className="font-display text-2xl mb-2">Copyright / IP infringement</h2>
            <p className="text-slateline-600 leading-relaxed">
              Email <a href="mailto:legal@xpert.company" className="text-brand-green underline hover:no-underline">legal@xpert.company</a> with:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-1 text-slateline-600 text-sm">
              <li>identification of the copyrighted work or right you hold;</li>
              <li>identification of the allegedly infringing material and where it is on the Service;</li>
              <li>your contact details;</li>
              <li>a statement that you have a good-faith belief the use is not authorised; and</li>
              <li>a statement, under penalty of perjury where applicable, that the information is accurate and you are authorised to act.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-display text-2xl mb-2">Abuse, harmful, or unlawful content</h2>
            <p className="text-slateline-600 leading-relaxed">
              Email <a href="mailto:abuse@xpert.company" className="text-brand-green underline hover:no-underline">abuse@xpert.company</a> describing
              the content and its location. For anything urgent or involving risk to a person, say so in the subject line.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl mb-2">Security vulnerabilities</h2>
            <p className="text-slateline-600 leading-relaxed">
              Please report responsibly to <a href="mailto:security@xpert.company" className="text-brand-green underline hover:no-underline">security@xpert.company</a>.
            </p>
          </div>
        </section>
      </main>
      <MarketingFooter />
    </div>
  );
}
